import {CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailScreenComponent } from './detail-screen/detail-screen.component';
import {DetailPanelComponent} from './detail-panel/detail-panel.component';
import {DetailsNameValueComponent} from './name-and-value/details-name-value.component';
import {DetailButtonComponent} from './detail-button/detail-button.component';
import {ClaimsTableComponent} from './detail-table/claims/claims-table.component';
import {MatDividerModule} from '@angular/material/divider';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTableModule} from '@angular/material/table';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {ClaimsFinancialFactComponent} from './detail-table/claims/claims-financial-fact.component';
import {LeaseObjectsTableComponent} from './detail-table/lease-objects/lease-objects-table.component';
import {ParticipatingAccountsTableComponent} from './detail-table/participating-accounts/participating-accounts-table.component';
import {CostsTableComponent} from './detail-table/costs/costs-table.component';
import {CostsPopupComponent} from './screens/popups/costs/costs-popup.component';
import {CommissionPopupComponent} from './screens/popups/commission/commission-popup.component';
import {CreditInterestPopupComponent} from './screens/popups/credit-interest/credit-interest-popup.component';
import {DebitInterestPopupComponent} from './screens/popups/debit-interest/debit-interest-popup.component';
import {CommissionTableComponent} from './detail-table/commission/commission-table.component';
import {DebitInterestTableComponent} from './detail-table/debit-interest/debit-interest-table.component';
import {LinkIdTableComponent} from './detail-table/link-id/link-id-table.component';
import {CreditInterestTableComponent} from './detail-table/credit-interest/credit-interest-table.component';
import {DebitCardPopupComponent} from './screens/popups/debitcard/debitcard-popup.component';
import {PhysicalCardTableComponent} from './detail-table/debit-card/physical-card/physical-card-table.component';
import {RequestedPhysicalCardTableComponent} from './detail-table/debit-card/requested-physical-card/requested-physical-card-table.component';
import {MobileCardTableComponent} from './detail-table/debit-card/mobile-card/mobile-card-table.component';
import {RequestedMobileCardTableComponent} from './detail-table/debit-card/requested-mobile-card/requested-mobile-card-table.component';
import {PopupContinentsComponent} from './detail-table/debit-card/popup-continents-table/popup-continents-table.component';
import {CreditCardTableComponent} from './detail-table/credit-card/card/card-table.component';
import {RequestedCreditCardTableComponent} from './detail-table/credit-card/requested-card/requested-card-table.component';
import {OnlineKeyTableComponent} from './detail-table/online-keys/card/onlinekey-card-table.component';
import {OnlinekeyRequestedCardTableComponent} from './detail-table/online-keys/requestedcards/onlinekey-requested-card-table.component';
import {OnlineKeySearchComponent} from './detail-table/online-keys/search/onlinekey-search.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IdealProfileTableComponent} from './detail-table/ideal-profile/idealprofile-card-table.component';
import {AccountDirectDebitListingsComponent} from './screens/popups/account-direct-debit-listings/account-direct-debit-listings.component'
import {VolmachtProductsTableComponent} from "./detail-table/volmacht/volmacht-products/volmacht-products-table.component";
import {VolmachtGrantorsTableComponent} from "./detail-table/volmacht/volmacht-grantors/volmacht-grantors-table.component";
import {VolmachtGranteesTableComponent} from "./detail-table/volmacht/volmacht-grantees/volmacht-grantees-table.component";
import {CreditorListingsComponent} from "./detail-table/account-direct-debit-listings/creditor-listings-table/creditor-listings.component";
import {MandateListingsComponent} from "./detail-table/account-direct-debit-listings/mandate-listings-table/mandate-listings.component";
import {RestrictedMandateListingsComponent} from "./detail-table/account-direct-debit-listings/restricted-mandate-listings-table/restricted-mandate-listings.component";
import {MandatesComponent} from "./screens/popups/mandates/mandates.component";
import {MandatesTableComponent} from "./detail-table/mandates/mandates-table.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    ReactiveFormsModule,
  ],
  declarations: [
    DetailScreenComponent,
    DetailPanelComponent,
    DetailsNameValueComponent,
    DetailButtonComponent,
    ClaimsTableComponent,
    ClaimsFinancialFactComponent,
    LeaseObjectsTableComponent,
    ParticipatingAccountsTableComponent,
    PhysicalCardTableComponent,
    RequestedPhysicalCardTableComponent,
    MobileCardTableComponent,
    RequestedMobileCardTableComponent,
    CreditCardTableComponent,
    RequestedCreditCardTableComponent,
    OnlineKeyTableComponent,
    OnlineKeySearchComponent,
    OnlinekeyRequestedCardTableComponent,
    PopupContinentsComponent,
    CostsTableComponent,
    DebitInterestTableComponent,
    CreditInterestTableComponent,
    LinkIdTableComponent,
    CommissionTableComponent,
    CostsPopupComponent,
    CommissionPopupComponent,
    CreditInterestPopupComponent,
    DebitInterestPopupComponent,
    DebitCardPopupComponent,
    IdealProfileTableComponent,
    VolmachtProductsTableComponent,
    VolmachtGrantorsTableComponent,
    VolmachtGranteesTableComponent,
    AccountDirectDebitListingsComponent,
    CreditorListingsComponent,
    MandateListingsComponent,
    RestrictedMandateListingsComponent,
    MandatesComponent,
    MandatesTableComponent
  ],
  exports: [DetailScreenComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class DetailScreensModule { }
